import { gql } from '@apollo/client';

export const GET_REGIONALS =  gql`
    query GetRegionals {
        regionals {
            id
            name
        }
    }
`